import React from 'react';
import TeaCupMarketing from './TeaCupMarketing';

const NoticeMarketing = () => <TeaCupMarketing mode="notice-marketing" />;

export default NoticeMarketing;
